var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images-wrapper"},[_vm._l((_vm.imgs.slice(0, 4)),function(item,index){return _c('img',{key:index,style:({
      width: _vm.findWidth(_vm.imgs.slice(0, 4).length, index),
      height: _vm.findheight(_vm.imgs.slice(0, 4).length, index),
    }),attrs:{"src":_vm.$store.state.ASSETS_BASE_URL + '/feeds/' + item},on:{"click":function($event){return _vm.viewMoreImages()}}})}),(_vm.imgs.length > 4)?_c('div',{staticClass:"more-images",on:{"click":function($event){return _vm.viewMoreImages()}}},[_vm._v(" +"+_vm._s(_vm.imgs.length - 4)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }